export * from './url'

export function isSportsbookCollectionValid (collection) {
  return (
    Array.isArray(collection) && (collection.length > 0)
  )
}

export function isSportsbookMapValid (map) {
  return map && // null and undefined check
    Object.keys(map).length > 0 // props check
}
